import { CREDIT_SUBMISSION_DECISION } from './getById';
import { CREATE_CREDIT_SUBMISSION_DECISION } from './create';
import { UPDATE_CREDIT_SUBMISSION_DECISION } from './update';

export * from './fragments';

export const creditSubmissionDecisionApi = {
  getById: CREDIT_SUBMISSION_DECISION,
  create: CREATE_CREDIT_SUBMISSION_DECISION,
  update: UPDATE_CREDIT_SUBMISSION_DECISION,
};

export * from './useCSDecision';
